class Toolbar {
  constructor(app) {
    this.app = app;
    this.container = null;
    this.buttons = {};
    this.saveDialog = null;
    this.loadDialog = null;
  }

  init() {
    this.createToolbar();
    this.createSaveDialog();
    this.createLoadDialog();
    this.updateButtons();
  }

  createToolbar() {
    // Container principale
    this.container = document.createElement('div');
    this.container.id = 'toolbar';
    this.container.className = 'toolbar';

    // Bottone Salva
    this.buttons.save = this.createButton(
      '💾',
      'Salva Progetto (S)',
      () => this.showSaveDialog()
    );

    // Bottone Carica
    this.buttons.load = this.createButton(
      '📂',
      'Carica Progetto (C)',
      () => this.showLoadDialog()
    );

    // Bottone Aggiorna
    this.buttons.update = this.createButton(
      '🔄',
      'Aggiorna Progetto (A)',
      () => this.app.updateProject()
    );

    // Separatore
    const separator = document.createElement('div');
    separator.className = 'toolbar-separator';

    // Bottone Lucchetto
    this.buttons.lock = this.createButton(
      '🔓',
      'Blocca Progetto (L)',
      () => this.app.toggleLock()
    );
    this.buttons.lock.classList.add('lock-button', 'unlocked');

    // Aggiungi bottoni al container
    this.container.appendChild(this.buttons.save);
    this.container.appendChild(this.buttons.load);
    this.container.appendChild(this.buttons.update);
    this.container.appendChild(separator);
    this.container.appendChild(this.buttons.lock);

    // Nome progetto corrente (inizialmente nascosto)
    this.projectNameLabel = document.createElement('div');
    this.projectNameLabel.className = 'project-name-label';
    this.projectNameLabel.style.display = 'none';

    // Aggiungi al DOM
    document.body.appendChild(this.container);
    document.body.appendChild(this.projectNameLabel);
  }

  createButton(icon, tooltip, onClick) {
    const button = document.createElement('button');
    button.className = 'toolbar-button';
    button.innerHTML = `<span class="toolbar-icon">${icon}</span>`;
    button.title = tooltip;
    button.addEventListener('click', onClick);
    return button;
  }

  // ========== DIALOG SALVA ==========

  createSaveDialog() {
    this.saveDialog = document.createElement('div');
    this.saveDialog.className = 'dialog-overlay';
    this.saveDialog.style.display = 'none';

    const container = document.createElement('div');
    container.className = 'dialog-container';

    // Titolo
    const title = document.createElement('h2');
    title.className = 'dialog-title';
    title.textContent = 'Salva Progetto';

    // Form
    const form = document.createElement('form');
    form.className = 'dialog-form';

    // Input nome progetto
    const nameGroup = document.createElement('div');
    nameGroup.className = 'form-group';

    const label = document.createElement('label');
    label.textContent = 'Nome Progetto';

    const input = document.createElement('input');
    input.type = 'text';
    input.name = 'projectName';
    input.placeholder = 'es. Casa Vacanze';
    input.required = true;

    nameGroup.appendChild(label);
    nameGroup.appendChild(input);

    // Bottoni
    const buttonsContainer = document.createElement('div');
    buttonsContainer.className = 'dialog-buttons';

    const cancelButton = document.createElement('button');
    cancelButton.type = 'button';
    cancelButton.textContent = 'Annulla';
    cancelButton.className = 'dialog-button cancel';
    cancelButton.addEventListener('click', () => this.hideSaveDialog());

    const saveButton = document.createElement('button');
    saveButton.type = 'submit';
    saveButton.textContent = 'Salva';
    saveButton.className = 'dialog-button submit';

    buttonsContainer.appendChild(cancelButton);
    buttonsContainer.appendChild(saveButton);

    form.appendChild(nameGroup);
    form.appendChild(buttonsContainer);

    // Submit handler
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const projectName = input.value.trim();
      
      if (projectName) {
        saveButton.disabled = true;
        saveButton.textContent = 'Salvataggio...';

        try {
          await this.app.saveProject(projectName);
          this.hideSaveDialog();
          form.reset();
        } catch (error) {
          alert('Errore durante il salvataggio: ' + error.message);
        } finally {
          saveButton.disabled = false;
          saveButton.textContent = 'Salva';
        }
      }
    });

    container.appendChild(title);
    container.appendChild(form);
    this.saveDialog.appendChild(container);

    // Click su overlay per chiudere
    this.saveDialog.addEventListener('click', (e) => {
      if (e.target === this.saveDialog) {
        this.hideSaveDialog();
      }
    });

    document.body.appendChild(this.saveDialog);
  }

  showSaveDialog() {
    this.saveDialog.style.display = 'flex';
    const input = this.saveDialog.querySelector('input[name="projectName"]');
    input.focus();
  }

  hideSaveDialog() {
    this.saveDialog.style.display = 'none';
    const form = this.saveDialog.querySelector('form');
    form.reset();
  }

  // ========== DIALOG CARICA ==========

  createLoadDialog() {
    this.loadDialog = document.createElement('div');
    this.loadDialog.className = 'dialog-overlay';
    this.loadDialog.style.display = 'none';

    const container = document.createElement('div');
    container.className = 'dialog-container load-dialog';

    // Titolo
    const title = document.createElement('h2');
    title.className = 'dialog-title';
    title.textContent = 'Carica o Elimina Progetto';

    // Lista progetti
    this.projectsList = document.createElement('div');
    this.projectsList.className = 'projects-list';

    // Riga inferiore con i due bottoni
    const footerRow = document.createElement('div');
    footerRow.className = 'dialog-buttons';
    footerRow.style.marginTop = '16px';

    // Bottone Chiudi
    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.textContent = 'Chiudi';
    closeButton.className = 'dialog-button cancel';
    closeButton.addEventListener('click', () => this.hideLoadDialog());

    // Bottone Nuovo Progetto
    const newProjectButton = document.createElement('button');
    newProjectButton.type = 'button';
    newProjectButton.textContent = 'Nuovo Progetto';
    newProjectButton.className = 'dialog-button submit';
    newProjectButton.addEventListener('click', () => {
      if (confirm('Vuoi iniziare un nuovo progetto? La scena corrente verrà cancellata.')) {
        this.app.newProject();
        this.hideLoadDialog();
      }
    });

    footerRow.appendChild(closeButton);
    footerRow.appendChild(newProjectButton);    

    container.appendChild(title);
    container.appendChild(this.projectsList);
    container.appendChild(footerRow);
    this.loadDialog.appendChild(container);

    // Click su overlay per chiudere
    this.loadDialog.addEventListener('click', (e) => {
      if (e.target === this.loadDialog) {
        this.hideLoadDialog();
      }
    });

    document.body.appendChild(this.loadDialog);
  }

  async showLoadDialog() {
    this.loadDialog.style.display = 'flex';
    await this.refreshProjectsList();
  }

  hideLoadDialog() {
    this.loadDialog.style.display = 'none';
  }

  async refreshProjectsList() {
    this.projectsList.innerHTML = '<div class="loading">Caricamento progetti...</div>';

    try {
      const projects = await this.app.getAllProjects();

      if (projects.length === 0) {
        this.projectsList.innerHTML = '<div class="no-projects">Nessun progetto salvato</div>';
        return;
      }

      this.projectsList.innerHTML = '';

      projects.forEach(project => {
        const projectItem = document.createElement('div');
        projectItem.className = 'project-item';

        // Info progetto
        const projectInfo = document.createElement('div');
        projectInfo.className = 'project-info';

        const projectName = document.createElement('div');
        projectName.className = 'project-name';
        projectName.textContent = project.name;

        const projectDate = document.createElement('div');
        projectDate.className = 'project-date';
        
        if (project.updatedAt) {
          const date = project.updatedAt.toDate();
          projectDate.textContent = this.formatDate(date);
        }

        projectInfo.appendChild(projectName);
        projectInfo.appendChild(projectDate);

        // Bottoni
        const projectButtons = document.createElement('div');
        projectButtons.className = 'project-buttons';

        const loadButton = document.createElement('button');
        loadButton.textContent = 'Carica';
        loadButton.className = 'project-button load';
        loadButton.addEventListener('click', async () => {
          loadButton.disabled = true;
          loadButton.textContent = 'Caricamento...';

          try {
            await this.app.loadProject(project.id);
            this.hideLoadDialog();
          } catch (error) {
            alert('Errore durante il caricamento: ' + error.message);
          } finally {
            loadButton.disabled = false;
            loadButton.textContent = 'Carica';
          }
        });

        const deleteButton = document.createElement('button');
        deleteButton.textContent = 'Elimina';
        deleteButton.className = 'project-button delete';
        deleteButton.addEventListener('click', async () => {
          if (confirm('Sei sicuro di voler eliminare questo progetto?')) {
            deleteButton.disabled = true;
            deleteButton.textContent = 'Eliminazione...';

            try {
              await this.app.deleteProject(project.id);
              await this.refreshProjectsList();
            } catch (error) {
              alert('Errore durante l\'eliminazione: ' + error.message);
              deleteButton.disabled = false;
              deleteButton.textContent = 'Elimina';
            }
          }
        });

        projectButtons.appendChild(loadButton);
        projectButtons.appendChild(deleteButton);

        projectItem.appendChild(projectInfo);
        projectItem.appendChild(projectButtons);

        this.projectsList.appendChild(projectItem);
      });
    } catch (error) {
      this.projectsList.innerHTML = '<div class="error">Errore caricamento progetti</div>';
      console.error(error);
    }
  }

  formatDate(date) {
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Pochi secondi fa';
    if (diffMins < 60) return `${diffMins} minuti fa`;
    if (diffHours < 24) return `${diffHours} ore fa`;
    if (diffDays < 7) return `${diffDays} giorni fa`;

    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  // ========== AGGIORNAMENTI UI ==========

  updateButtons() {
    const projectManager = this.app.projectManager;

    // Aggiorna
    this.buttons.update.disabled = !projectManager.hasCurrentProject();

    // Nome progetto
    const projectName = projectManager.getCurrentProjectName();
    if (projectName) {
      this.projectNameLabel.textContent = `📁 ${projectName}`;
      this.projectNameLabel.style.display = 'block';
    } else {
      this.projectNameLabel.style.display = 'none';
    }

    // Aggiorna lucchetto
    this.updateLockButton();
  }

  updateLockButton() {
    const locked = this.app.isLocked;
    const btn = this.buttons.lock;
    if (!btn) return;

    if (locked) {
      btn.innerHTML = `<span class="toolbar-icon">🔒</span>`;
      btn.title = 'Sblocca Progetto (L)';
      btn.classList.remove('unlocked');
      btn.classList.add('locked');
    } else {
      btn.innerHTML = `<span class="toolbar-icon">🔓</span>`;
      btn.title = 'Blocca Progetto (L)';
      btn.classList.remove('locked');
      btn.classList.add('unlocked');
    }
  }

  dispose() {
    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
    if (this.saveDialog && this.saveDialog.parentNode) {
      this.saveDialog.parentNode.removeChild(this.saveDialog);
    }
    if (this.loadDialog && this.loadDialog.parentNode) {
      this.loadDialog.parentNode.removeChild(this.loadDialog);
    }
    if (this.projectNameLabel && this.projectNameLabel.parentNode) {
      this.projectNameLabel.parentNode.removeChild(this.projectNameLabel);
    }
  }
}

export default Toolbar;